/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { FormControl, FormHelperText, TextareaAutosize, TextField } from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import InfoIcon from '@material-ui/icons/Info';

// import { Circle } from 'components/Loading';
import SearchIcon from 'assets/icons/Search.svg';
import classes from './Text.module.scss';

const TextInput = (props) => {
  const {
    errorText,
    touched,
    label,
    required,
    error,
    className,
    type,
    variant,
    ref,
    setRef,
    inputIcon,
    loading,
    formProps,
    isEyeVisibilityIcon,
    searchIcon,
    customLeftIconTop,
    value,
    placeholder,
    searchRightIcon,
    hideErrorMessage,
    multiline,
    hideErrorIcon,
    ...other
  } = props;
  const [visibilityInput, setVisibilityInput] = useState(false);
  const requireRender = () => {
    return required && <span className='required-mark'>*</span>;
  };
  const getError = () => {
    if (touched) {
      return !!errorText;
    }
    return false;
  };
  const Element = React.useMemo(() => {
    if (multiline) return TextareaAutosize;
    return TextField;
  }, [multiline]);
  return (
    <div
      className={clsx(
        classes.textInputWrapper,
        className,
        type === 'hidden' && classes.inputHidden,
        variant === 'outlined' && classes.variantOutlined,
        !label && classes.noLabel,
        searchIcon && classes.hadSearchIcon
      )}>
      <FormControl error={!!(touched && errorText)}>
        <Element
          margin='dense'
          placeholder={placeholder}
          inputRef={(el) => {
            if (setRef) {
              setRef(el);
            }
          }}
          error={getError()}
          disabled={other.disabled}
          label={
            <span>
              {label}
              {requireRender()}
            </span>
          }
          type={visibilityInput ? 'text' : type}
          variant={variant}
          value={value || ''}
          {...other}
          InputLabelProps={{
            shrink: true,
          }}
          className={clsx(other.disabled ? classes.inputDisabled : '')}
        />
        {/* {loading && (
                    <div className={classes.inputIcon}>
                      <Circle />
                    </div>
                )} */}
        {!!isEyeVisibilityIcon && (
          <div
            className={clsx(classes.inputIcon, other.disabled ? classes.inputIconDisabled : '')}
            onClick={() => {
              if (!other.disabled) {
                setVisibilityInput(!visibilityInput);
              }
            }}>
            {visibilityInput ? <Visibility /> : <VisibilityOff />}
          </div>
        )}
        {searchIcon && (
          <div
            className={clsx(classes.searchIcon)}
            style={
              customLeftIconTop && {
                top: customLeftIconTop || 41,
              }
            }>
            <img src={SearchIcon} title='search' alt='search' />
          </div>
        )}
        {searchRightIcon && (
          <div className={clsx(classes.searchRightIcon)}>
            <img src={SearchIcon} title='search' alt='search' />
          </div>
        )}
        {!!inputIcon && (
          <div className={clsx(classes.inputIcon, other.disabled ? classes.inputIconDisabled : '')}>
            {inputIcon}
          </div>
        )}
        {touched && errorText && !hideErrorIcon && (
          <div
            style={{
              position: 'absolute',
              top: 13,
              right: 10,
            }}>
            <InfoIcon
              style={{
                color: '#FF5555',
              }}
            />
          </div>
        )}
        {errorText && !hideErrorMessage && (
          <FormHelperText
            className={clsx(
              classes.errorText,
              touched && !!errorText ? '' : classes.errorTextHide
            )}>
            {errorText}
          </FormHelperText>
        )}
        {/* {touched && (errorText && <FormHelperText className={classes.hide}>{errorText}</FormHelperText>)} */}
      </FormControl>
    </div>
  );
};

TextInput.defaultProps = {
  required: false,
  error: {},
  className: '',
  type: 'text',
  variant: 'outlined',
  setRef: () => {},
  inputIcon: null,
  loading: false,
  ref: null,
  errorText: '',
  formProps: {},
  isEyeVisibilityIcon: false,
  searchIcon: false,
  label: '',
  touched: false,
  value: '',
  placeholder: '',
  inputStyle: {},
  hideErrorIcon: false,
};

TextInput.propTypes = {
  inputIcon: PropTypes.object,
  ref: PropTypes.object,
  error: PropTypes.object,
  className: PropTypes.any,
  label: PropTypes.any,
  setRef: PropTypes.func,
  errorText: PropTypes.any,
  formProps: PropTypes.any,
  type: PropTypes.string,
  variant: PropTypes.string,
  touched: PropTypes.any,
  required: PropTypes.bool,
  loading: PropTypes.bool,
  isEyeVisibilityIcon: PropTypes.bool,
  searchIcon: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placeholder: PropTypes.string,
  inputStyle: PropTypes.object,
  hideErrorIcon: PropTypes.bool,
};

export default TextInput;
